export const ListingTypeConstants = {
    SHOOTING_RANGE: '1fa0c55a-0de2-4edb-9119-abbce24a6651',
    ACCOMMODATION_AND_HUNT: '6fb68c1a-bc0d-4ab6-b639-d0972c1a165c',
    TRAINING_CENTRE: '0fd4cef8-6107-4054-a4dc-d18be33c8045'
};
